import { createFilterOptions } from '@mui/material'
import { Filter } from 'components/core/search-filter/filter'
import { GetJobTitleSearchTermsRequest } from 'pbts/c1/api/user/v1/user'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { getJobTitleSearchTermsApi } from 'redux_toolkit/users'

const UserJobTitleFilterOptions = createFilterOptions<string>({})

type UserJobTitleFilterProps = {
    value?: Array<string>
    onChange: (updated: { jobTitles: Array<string> }, shouldPropagate?: boolean) => void
}

export const UserJobTitleFilter = ({ value, onChange: _onChange }: UserJobTitleFilterProps): React.ReactElement => {
    const intl = useIntl()
    const { data: jobTitleResponse } = getJobTitleSearchTermsApi.useGetJobTitleSearchTerms(
        GetJobTitleSearchTermsRequest.create({}),
    )

    const jobTitleOptions = jobTitleResponse?.terms || []

    const renderLabel = useCallback(
        (jobTitle: string): string => jobTitle,
        [],
    )

    const onChange = useCallback((jobTitles: Array<string>) => _onChange({ jobTitles }, true), [_onChange])

    return (
        <Filter
            label={intl.formatMessage({
                id: 'user_filter_job_title_type',
                defaultMessage: 'Job title',
            })}
            options={jobTitleOptions}
            selected={value}
            onChange={onChange}
            filterOptions={UserJobTitleFilterOptions}
            renderLabel={renderLabel}
        />
    )
}
